import { Plugins } from '@leverege/plugin';
import { ModelFactory } from '@leverege/ui-plugin';
import StringUtil from '@leverege/string-util';
import AttributeCoordinateModel from "../models/coordinate/AttributeCoordinateModel.js";
import Scale from "../models/scale/index.js";
export default {
  install(opts) {
    let coordinateCreatorOnChange = null;
    const dirty = evt => {
      if (coordinateCreatorOnChange) {
        coordinateCreatorOnChange();
      }
    };
    Plugins.on('Attribute', dirty);
    Plugins.add('CoordinateCreator', {
      name: 'AttributeCoordinateCreator',
      onChange: cb => {
        coordinateCreatorOnChange = cb;
      },
      create: () => {
        const plgs = Plugins.get('Attribute');
        const coordinates = [];
        plgs.forEach(attr => {
          const s = attributeToCoordinate(attr);
          if (s != null) {
            coordinates.push(s);
          }
        });
        return coordinates;
      }
    });
    function attributeToCoordinate(attr) {
      let model = ModelFactory.get(`attr.coordinate.${attr.valueType}`);
      let formatter = null;
      const scale = Scale.createScaleModel(attr.valueType);
      if (model == null) {
        formatter = ModelFactory.get(`attr.formatter.${attr.valueType}`);
        if (formatter) {
          model = AttributeCoordinateModel;
        } else {
          return null;
        }
      }
      return {
        name: attr.displayName || StringUtil.camelCaseToTitleCase(attr.name),
        attrName: attr.name,
        objectType: attr.objectType,
        valueType: attr.valueType,
        layout: {
          ...attr.layout
        },
        create: () => {
          let json = model.create(attr.name, attr.objectType);
          json = model.setLabel(json, attr.displayName || StringUtil.camelCaseToTitleCase(attr.name));
          if (formatter) {
            json = model.setFormatter(json, formatter.create());
          }
          json = model.setScale(json, scale);
          return json;
        }
      };
    }
  }
};